import {
  get,
  defer,
} from 'lodash-es'
import cookie from 'cookie-cutter'
import appProps from '../app-props'
import RiotControl from 'riotcontrol'

const refreshLimit = appProps.get('checksum.refresh.limit')

class AjaxUtils {

  static checkForBadChecksum(xhr) {
    return get(xhr, 'responseJSON.error["0"].code') === 10000
  }

  static checkForNoOrder(xhr) {
    return get(xhr, 'responseJSON.error["0"].code') === 10100
  }

  static handleChecksumMismatch() {
    // Retrieve the checkout refresh attempts cookie
    const checkoutRefreshAttempts = parseInt(cookie.get('checkout_ra'), 10) || 0

    // if the count is below the limit
    if (!isNaN(checkoutRefreshAttempts) && checkoutRefreshAttempts < refreshLimit) {
      // Set the cookie to the current checkoutRefreshAttempts + 1, 30 seconds from now
      const date = new Date()
      date.setTime(date.getTime() + (30 * 1000))

      cookie.set('checkout_ra', checkoutRefreshAttempts + 1, { expires: date.toGMTString() })

      // Refresh the browser
      defer(() => {
        window.location.href = '/checkout' // eslint-disable-line no-undef
      })
    } else {
      // Else, trigger the we're having difficulty modal
      RiotControl.trigger('modalFactory.create', {
        title: 'Online Order Error',
        template: 'refresh-limit-modal',
        buttons: [{
          title: 'Ok',
          el_classes: 'btn btn-primary',
          on_click: () => {},
          on_keypress: () => {},
        }],
      })
    }
  }

  static handleNoOrder() {
    defer(() => {
      window.location.href = '/ShoppingCart' // eslint-disable-line no-undef
    })
  }
}

export default AjaxUtils
